import Big from 'big.js';

type SelectedProduct = {
  qty?: string;
  details?: {
    product?: {
      labour_qty?: string;
    };
  };
};

export const calculateTotalHours = (products?: SelectedProduct[]) => {
  if (!products) return 0;

  return products.reduce((total: number, item) => {
    const { details, qty } = item || {};
    if (!details?.product?.labour_qty || !qty) return total;

    const hours = Big(details.product.labour_qty).times(qty).toNumber();
    return total + hours;
  }, 0);
};
